import angular from "angular";
import Vue from "vue";
import "ngVue";

import dcStudentProgressOverview from "./StudentProgressOverview.vue";

export default angular
  .module("directives.studentProgressOverview", [])
  .directive("dcStudentProgressOverview", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcStudentProgressOverview", dcStudentProgressOverview),
      );
    },
  ]);
